import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router) {}

    private restoreHandoffSession(routeSnapshot: ActivatedRouteSnapshot): void {
        const handoffKey = routeSnapshot.queryParams['session_handoff'];
        if (!handoffKey) { return; }
        const raw = localStorage.getItem(handoffKey);
        if (!raw) { return; }
        try {
            const data = JSON.parse(raw);
            Object.keys(data).forEach(k => sessionStorage.setItem(k, data[k]));
        } catch (e) {}
        localStorage.removeItem(handoffKey);
    }

    canActivate(routeSnapshot: ActivatedRouteSnapshot) {
        this.restoreHandoffSession(routeSnapshot);
        //console.log(routeSnapshot);
        if (sessionStorage.getItem('isLoggedIn')) {
            if(routeSnapshot.data['id'] === 0) {
                return true;
            }

            if (AuthService.checkPermissions(routeSnapshot.data['id'])) {
                return true;
            } else {
                this.router.navigate(['/']);
                return;
            }
        } else {
            if(routeSnapshot.data['id'] === -1) {
                return true;
            }
        }


        this.router.navigate(['/login']);
        return;
    }

    canActivateChild() {
        if (AuthService.isAdmin() || AuthService.isSuperAdmin()) {
            return true;
        }

        this.router.navigate(['/dashboard']);
        return false;
    }
}
